module.exports = __webpack_public_path__ + "img/dandan.ad91320a.png";